import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { SmallSpinner } from "../../Icon";

function VendorOverlayModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-center"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-center">
                    Vendor Overlay Upload
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.File
                        id="custom-file-translate-html"
                        label="accept xls, xlsx files"
                        data-browse="Excel Files"
                        custom
                        onChange={props.handleSetOverlay}
                    />
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={props.loading} onClick={props.uploadOverlay}>
                    {props.loading && <SmallSpinner />} Upload
                </Button>
                <Button
                    disabled={props.loading}
                    variant={"secondary"}
                    onClick={props.onHide}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
export default VendorOverlayModal;